import React, { useState, useEffect, useCallback } from "react";
import "./layout.css";
import { ThemeProvider } from "styled-components";
import { Outlet } from "react-router-dom";
import Header from "./Header/Header";
import Sidebar from "./Sidebar/Sidebar";

const Layout = ({ children }) => {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== "undefined" && window.innerWidth < 1024
  );
  
  // Desktop opens by default (>= 1024px); mobile/tablet starts closed (< 1024px).
  const [isClosed, setIsClosed] = useState(
    () => typeof window !== "undefined" && window.innerWidth < 1024
  );

  useEffect(() => {
    const updateSize = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);
      if (mobile) {
        setIsClosed(true);
      }
    };
    window.addEventListener("resize", updateSize);
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  // Sync collapsed state with document.body class list
  useEffect(() => {
    if (isClosed) {
      document.body.classList.add("sidebar-collapsed");
    } else {
      document.body.classList.remove("sidebar-collapsed");
    }
  }, [isClosed]);

  const toggleSidebar = useCallback(() => {
    setIsClosed((prev) => {
      const next = !prev;
      return next;
    });
  }, []);


  return (
    <ThemeProvider theme={{ fontFamily: "Poppins" }}>
      <div className="app-shell flex h-screen w-full overflow-hidden font-body-md text-body-md text-on-surface antialiased">
        <Sidebar
          isMobile={isMobile}
          isClosed={isClosed}
          toggleSidebar={toggleSidebar}
        />

        <main className="app-main flex-1 flex flex-col h-full overflow-hidden min-w-0">
          <Header toggleSidebar={toggleSidebar} isClosed={isClosed} />
          {children || <Outlet />}
        </main>
      </div>
    </ThemeProvider>
  );
};

export default Layout;
